import './ToggleGroup.css';
export default {
    "white": "#fff",
    "neutral-100": "#f8f7fa",
    "neutral-200": "#efedf2",
    "neutral-300": "#dddae3",
    "neutral-400": "#c1bdc7",
    "neutral-500": "#918d99",
    "neutral-600": "#716b7a",
    "neutral-700": "#585163",
    "neutral-800": "#3a3247",
    "neutral-900": "#261b36",
    "neutral-1000": "#13002d",
    "root": "ToggleGroup_root__w63sq",
    "item": "ToggleGroup_item__w63sq",
    "selected": "ToggleGroup_selected__w63sq",
    "equalWidth": "ToggleGroup_equalWidth__w63sq"
};
